import { Component, AfterViewInit,OnInit } from '@angular/core';
import {DataService} from '../data.service';
import {Router} from '@angular/router';
import {HomeComponent} from '../home/home.component';

declare var $ : any;

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.css']
})
export class SitemapComponent implements OnInit,AfterViewInit {
  data:any[]=[];
  userTypeId:number=-1;
  planId:number=-1;
  isNext:boolean=false;
  companyId:number=-1;
  constructor(private service:DataService,private router:Router,private home : HomeComponent) { }

  ngOnInit() {
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
    this.companyId=sessionStorage.getItem("companyId")==null ? -1 : parseInt(sessionStorage.getItem("companyId"));
    this.getAllThemesForSite();
  }

  ngAfterViewInit(){
    $('.cd-header').css('backgroundColor','rgba(148,18,70,0.96)');
  }

  getAllThemesForSite(){
    this.service.GetAllThemesForSite({'CompanyId':this.companyId})
    .subscribe(
      (result:any[])=>{
        if(result['Status']=="Success"){
          this.data=result['ThemeData'];
        } else{
          this.service.alert(result['Message'],'error');
        }
      },
      (error)=>{
        console.log(error);
      }
    )
  }

  goToModule(pvarName,pvarId){
    let name=pvarName.replace(' ','-');
    this.router.navigate(['module',name,pvarId]);

  }

  showActiveModule(pvarId){
    this.home.showActiveModule(pvarId);
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/sitemap/sitemap.component.ts